// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"864":"06c19596","5821":"275e404e","7662":"43783929","7672":"dd0bff09","7964":"4c0e9c71"}[chunkId] + ".chunk.css";
};